module.exports = "<div style='width:400px;height:400px;'>\n    <canvas id='funnel-graph-canvas' width=800 height=800></canvas>\n</div>\n"